import { MethodType } from '../constants/MethodType'

const api = require('./api')

export const fetchConsumerList = (brandId, params) => api.request(1, `/getConsumerList/${brandId}`, MethodType.GET, params)

export const fetchConsumerDetail = (brandId, consumerId, params) => api.request(1, `/getConsumerDetail/${brandId}/${consumerId}`, MethodType.GET, params)
